import { useTranslation } from 'next-i18next';
import React, { ReactElement } from 'react';
import { FdrAgency, FdrImage } from '@hotelplan/supergraph-api';
import {
  FdrAgencyContactModule,
  FdrAgencyHeroWrapper,
  FdrAgencyTextBlock,
} from 'components/domain/fdr-agency-detail';
import { FdrAgencyMap } from 'components/domain/fdr-agency-map';
import { FdrHeroSection } from 'components/domain/fdr-hero-section';
import { FdrPageComponents } from 'components/domain/fdr-page-components';
import { TextBlockContainer } from 'components/domain/text-block/TextBlockContainer';
import { FdrAgencyFullInfoFragment } from 'schemas/query/agencies/fdr-agency.generated';
import { useFdrAgencyOverviewAgenciesQuery } from 'schemas/query/agency-overview/fdr-agency-overview-agencies.generated';

export { getServerSideProps } from 'components/page/agency-detail/agency-detail.gssp';

const AGENCY_MAP_ZOOM = 17;

interface IAgencyPageProps {
  agency: FdrAgencyFullInfoFragment;
}

export default function AgencyPage({ agency }: IAgencyPageProps): ReactElement {
  const [t] = useTranslation('agency');

  const {
    name,
    address,
    hero,
    agencyMainText,
    pageComponents,
    coordinates,
    phone,
    appointmentLink,
    formLink,
    openingHours,
    timezone,
    specialHours,
    hasWheelchairAccessibleSeating,
  } = agency || {};

  const fdrAgencyOverviewAgenciesQuery = useFdrAgencyOverviewAgenciesQuery({
    skip: !agency,
  });

  if (!agency) return null;

  return (
    <>
      <FdrAgencyHeroWrapper>
        <FdrHeroSection
          title={name}
          text={address?.city}
          hero={hero as FdrImage}
        />
      </FdrAgencyHeroWrapper>

      <TextBlockContainer>
        <FdrAgencyTextBlock text={agencyMainText?.mainText} />
      </TextBlockContainer>
      <FdrPageComponents components={pageComponents?.components} />
      <FdrAgencyContactModule
        name={name}
        phone={phone}
        address={address}
        flagline={t('agency:contacts.flagline')}
        coordinates={coordinates}
        appointmentLink={appointmentLink}
        formLink={formLink}
        openingHours={openingHours}
        specialHours={specialHours}
        timezone={timezone}
        hasWheelchairAccessibleSeating={hasWheelchairAccessibleSeating}
      />
      {/* TODO: add map loader ? */}
      <FdrAgencyMap
        agencies={
          fdrAgencyOverviewAgenciesQuery?.data?.fdrAgenciesOverview
            ?.agencies as Array<FdrAgency>
        }
        initialMapZoom={AGENCY_MAP_ZOOM}
      />
    </>
  );
}
